import { createFileRoute } from '@tanstack/react-router'

import { SubscriptionV2StepPageIndex } from '../../../../components/pages/subscription-v2/subscription-v2-step-page-index.tsx'

export const Route = createFileRoute('/subscribe/$subscriptionId/$stepId/')({
  component: SubscriptionV2StepPageIndex,
})
